import React from 'react';
import PropTypes from 'prop-types';

import {useDropzone} from 'react-dropzone';

const UploadFile = (props) => {
  const openDialog = props.openDialog;
  const uploadFile = props.uploadFile;

  const onDrop = async (files) => {
    for (const file of files) {
      uploadFile(file, URL.createObjectURL(file));
    }
  };
  const {getRootProps, getInputProps, open} = useDropzone({
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/gif': ['.gif'],
      'image/bmp': ['.bmp'],
      'image/tiff': ['.tiff', '.tif'],
      'image/webp': ['.webp'],
      'image/heif': ['.heif', '.heic'],
      'image/svg+xml': ['.svg'],
      'image/x-icon': ['.ico'],
    },
    onDrop,
    noKeyboard: true,
  });


  React.useEffect(() => {
    if (openDialog) {
      open();
    }
  }, [openDialog]);

  return (
    <>
      <div {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()} />
        {props.children}
      </div>
    </>
  );
};

UploadFile.propTypes = {
  uploadFile: PropTypes.func.isRequired,
  children: PropTypes.any,
  openDialog: PropTypes.any,
};

export default UploadFile;
